import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["trigger", "message", "modal", "header", "title", "body"]

  connect() {
    this.connected = true
    this.modalElement = this.modalTarget
    this.observer = new ResizeObserver(() => this.refresh())
    this.messageTargets.forEach(message => this.observer.observe(message))
    this.restoreFocus = () => {
      if (this.activeTrigger?.isConnected && !this.activeTrigger.disabled) this.activeTrigger.focus()
      this.activeTrigger = null
    }
    this.modalElement.addEventListener("hidden.bs.modal", this.restoreFocus)
    this.refresh()
    document.fonts.ready.then(() => { if (this.connected) this.refresh() })
  }

  disconnect() {
    this.connected = false
    this.observer.disconnect()
    this.modalElement.removeEventListener("hidden.bs.modal", this.restoreFocus)
    const modal = Modal.getInstance(this.modalElement)
    modal?.hide()
    modal?.dispose()
  }

  messageTargetConnected(message) {
    this.observer?.observe(message)
  }

  messageTargetDisconnected(message) {
    this.observer?.unobserve(message)
  }

  refresh() {
    this.triggerTargets.forEach(trigger => {
      const message = trigger.querySelector(".navbar-flash__message")
      const truncated = this.isTruncated(message)
      trigger.disabled = !truncated
      if (truncated) {
        trigger.title = trigger.dataset.readMore
        trigger.setAttribute("aria-haspopup", "dialog")
        trigger.setAttribute("aria-controls", this.modalTarget.id)
      } else {
        trigger.removeAttribute("title")
        trigger.removeAttribute("aria-haspopup")
        trigger.removeAttribute("aria-controls")
      }
    })
  }

  open(event) {
    const trigger = event.currentTarget
    const message = trigger.querySelector(".navbar-flash__message")
    if (!this.isTruncated(message)) return

    this.activeTrigger = trigger
    this.titleTarget.textContent = trigger.dataset.messageTitle
    this.bodyTarget.textContent = message.textContent
    const danger = trigger.dataset.danger === "true"
    this.headerTarget.classList.toggle("bg-danger", danger)
    this.headerTarget.classList.toggle("bg-success", !danger)
    Modal.getOrCreateInstance(this.modalTarget).show(trigger)
  }

  isTruncated(message) {
    return message.scrollWidth > message.clientWidth + 1
  }
}
